import { publicConfig } from 'config'
import { linkBuilder } from 'links'
import { LinkedLinkProps } from 'shared-definitions/types'

export function postLinkBuilder(slug: string): LinkedLinkProps {
  return linkBuilder.buildSiteLink({ path: 'post', params: { slug } })
}

export function newsletterPageLinkBuilder(slug: string): LinkedLinkProps {
  return linkBuilder.buildSiteLink({ path: 'newsletterPage', params: { slug } })
}

export function authorLinkBuilder(slug: string): LinkedLinkProps {
  return linkBuilder.buildSiteLink({ path: 'author', params: { slug } })
}

export function contactLinkBuilder(message: string): LinkedLinkProps {
  return linkBuilder.buildSiteLink({
    path: 'contacts',
    query: {
      message: encodeURI(message),
    },
    hash: publicConfig('contactsFormId'),
  })
}

export function tagLinkBuilder(slug: string): LinkedLinkProps {
  return linkBuilder.buildSiteLink({ path: 'tag', params: { slug } })
}
